/*
  AMUMIN: het zwevende beoordelingslabel van Google ("Winkelbeoordeling door Google 4,9",
  #google-merchantwidget-iframe-wrapper, uit de app Google & YouTube) mag nooit over een kop of knop
  vallen. Het label staat linksonder (CSS in amumin-tokens.css). Zodra het een kop, knop of
  invoerveld raakt, vervaagt het; is het weer vrij, dan komt het terug. Tijdens het wachtlijstvenster
  en het mobiele menu is het weg (CSS op html.am-waitlist-open en body.overflow-hidden-*).
*/
(function () {
  if (window.__amuminBadgeGuard) return;
  window.__amuminBadgeGuard = true;

  var SELECTOR = 'h1, h2, h3, .h1, .h2, .am-button, .button, .am-eyebrow, input, select, [data-am-waitlist-open], .product-form__submit';
  var badge = null;
  var ticking = false;

  function overlaps(a, b) {
    return a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top;
  }

  function check() {
    ticking = false;
    if (!badge || !document.body.contains(badge)) {
      badge = document.getElementById('google-merchantwidget-iframe-wrapper');
      if (!badge) return;
    }
    var box = badge.getBoundingClientRect();
    if (!box.width || !box.height) return;
    // Iets ruimer dan het label zelf, zodat het nooit tegen tekst aan schuurt.
    var zone = { left: box.left - 8, right: box.right + 8, top: box.top - 8, bottom: box.bottom + 8 };
    var hit = false;
    var items = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < items.length && !hit; i++) {
      var el = items[i];
      if (badge.contains(el)) continue;
      // Alleen wat echt te zien is: niet het dichte menu, een dicht paneel of het wachtlijstvenster.
      if (el.offsetParent === null || el.closest('header-drawer, .mega-dropdown, dialog, [hidden]')) continue;
      var r = el.getBoundingClientRect();
      if (r.bottom < zone.top || r.top > zone.bottom || !r.width) continue;
      if (overlaps(zone, r)) hit = true;
    }
    document.documentElement.classList.toggle('am-badge-hidden', hit);
  }

  function schedule() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(check);
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  // Het label wordt later door Google ingeladen: een paar keer opnieuw kijken.
  var tries = 0;
  var poll = window.setInterval(function () {
    schedule();
    if (++tries > 20) window.clearInterval(poll);
  }, 500);
})();
